// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const NavItem = (el) => {
  const ui = {
    el,
    body: select('body', document),
    main: select('#main', document),
    toggles: select.all('button.nav-item', document),
    subnav: null,
  };

  const subNavExpanded = () => {
    const expanded = ui.el.getAttribute('aria-expanded');
    return expanded === 'true';
  };

  const closeAllSubnavs = () => {
    ui.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      ui.body.classList.remove('subnav-open');
    });
  };

  const handleToggle = () => {
    if (subNavExpanded()) {
      closeAllSubnavs();
    } else {
      closeAllSubnavs();
      el.setAttribute('aria-expanded', 'true');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && subNavExpanded()) {
      closeAllSubnavs();

      // If current focus is within the expanded subnav, return focus to the toggle button
      if (ui.subnav?.contains(document.activeElement)) {
        // console.log(ui.subnav, document.activeElement, ui.subnav?.contains(document.activeElement));
        el.focus();
      }
    }
  };

  const handleClickOutside = (event) => {
    if (subNavExpanded() && !ui.subnav.contains(event.target) && !ui.el.contains(event.target)) {
      closeAllSubnavs();
    }
  };

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      handleToggle();
    });

    document.addEventListener('keydown', (event) => {
      handleKeyDown(event);
    });

    document.addEventListener('click', (event) => {
      handleClickOutside(event);
    });
  };

  const init = () => {
    const controls = ui.el.getAttribute('aria-controls');
    if (controls) {
      ui.subnav = select(`#${controls}`, document);
    }

    addEvents();
  };

  init();
};

export default NavItem;
